import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { makeTaskManagementApi } from '../TaskManagementApi';
import { AxiosError, AxiosResponse } from 'axios';
import { ITaskAPI } from '../types/TaskManagementResponse';

export const useTask = (taskId: string, shouldMakeRequest: boolean) => {
  const taskManagementApi = makeTaskManagementApi();

  const taskResponse = useQuery<AxiosResponse<ITaskAPI>, AxiosError>({
    queryKey: ['tms-tasks', taskId],
    placeholderData: keepPreviousData,
    queryFn: () => {
      return taskManagementApi.getTask(taskId);
    },
    enabled: shouldMakeRequest,
    retry: false,
    staleTime: 1000,
  });

  return {
    task: taskResponse.data?.data ?? null,
    taskResponse,
  };
};
